import { Box, Checkbox } from '@chakra-ui/react';
import { Container } from 'components/Container';
import { ContainerHead } from 'components/ContainerHead';
import { DataTable } from 'components/DataTable/DataTable';
import { pastDueTable } from 'components/DataTable/DataTableModels';
import { PastDue } from 'models/ApiModels';
import { PortalContext } from 'PortalContext';
import React from 'react';
import { useApi } from '../lib/useApi';

export function DuePaymentsPage(): JSX.Element {
  const { data: dueResp, state: respState } = useApi<PastDue[]>(
    '/payments/order/pastdue',
  );
  const [showVitecPayments, setShowVitecPayments] = React.useState(false);

  const { dispatch } = React.useContext(PortalContext);

  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_STATE', payload: respState });
  }, [dispatch, respState]);

  if (respState !== 'success') return <></>;
  if (respState === 'success' && !respState?.length)
    return <p>Ingen data {respState}</p>;

  const filteredDueResp = (dueResp ?? []).filter(
    (item) => item?.order?.vitecPayment === showVitecPayments,
  );

  return (
    <>
      <ContainerHead children="" title="Sena betalningar" />
      <Container>
        <Box mb={4} maxW="260px">
          <Checkbox
            isChecked={showVitecPayments}
            onChange={(e): void => setShowVitecPayments(e.target.checked)}>
            Visa flyttade till Vitec
          </Checkbox>
        </Box>
        <DataTable
          tableDef={pastDueTable}
          data={filteredDueResp}
          searchableFields={['orderEmail', 'unitExternalId']}
        />
      </Container>
    </>
  );
}
